import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import merchant_services from "services/merchant_services";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";

export function useMerchantBalances(addresses: string[]) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery({
    // Same split as cards: the merchant list is token-independent, its balances are not.
    queryKey: ["balances", "merchants", addresses, token],
    queryFn: () =>
      merchant_services.fetchBalancesByAddresses(
        addresses,
        networkType,
        token,
      ),
    enabled: !!user && addresses.length > 0,
  });
}
